import Pieces from "./Pieces";
import styles from "./Board.module.css";
import { read } from "../chessUtils/fen";
import pieceStyles from "./Piece.module.css";
import React, { useRef } from "react";
import { ChessSets } from "@chesshotel/constants";

export default function DisplayBoard({
  fen,
  boardSize = 504,
  playingWhite = true,
  chessSet = ChessSets.CHESSHOTEL,
}) {
  const position = fen ? read(fen) : {};
  const pieceRefs = useRef({});

  const boardClass = styles[chessSet];

  return (
    <div
      className={`relative bg-cover border select-none w-[100vw] h-[100vw] md:w-[504px] md:h-[504px] border-altgray-100 ${boardClass}`}
      style={{
        width: boardSize + "px",
        height: boardSize + "px",
      }}
    >
      <div className={playingWhite ? "" : pieceStyles.flipped}>
        <Pieces
          freeMove={false}
          playingWhite={playingWhite}
          position={position}
          pieceRefs={pieceRefs}
          chessSet={chessSet}
          boardSize={boardSize}
        />
      </div>
    </div>
  );
}
